import { render, staticRenderFns } from "./ToolBoxWorkflow.vue?vue&type=template&id=6ff6561a&"
import script from "./ToolBoxWorkflow.vue?vue&type=script&lang=js&"
export * from "./ToolBoxWorkflow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports